import { Observable } from "rxjs";
import { BRAND_BARCODE_FIELDS_UPDATE, BRAND_GENERIC_UPDATE_COMPLETE } from "constants/action-types";
import siteConfig from "site-config";
import { formatMessage } from "lib/globalize-util";
import { ajax } from "lib/observable";
import "rxjs/add/operator/map";
import { add as snackbarAdd } from "actions/snackbars";

export const updateBarcodeFieldsEpic = (action$, store) => {
    return action$
        .ofType(BRAND_BARCODE_FIELDS_UPDATE)
        .map((action) => {
            return action.payload;
        })
        .concatMap((preferences) => {
            return ajax({
                method: "POST",
                body: preferences,
                url: `${siteConfig.api}/brand/barcode-settings`,
            })
                .map(({ response, status }) => {
                    if (response && status === 200) {
                        return { result: response, error: false };
                    } else {
                        return { error: true, result: [] };
                    }
                })
                .flatMap(({ result, error }) => {
                    if (error) {
                        return [
                            store.dispatch(snackbarAdd({ message: formatMessage("Error saving barcode fields") })),
                            {
                                payload: [],
                                error: true,
                                type: BRAND_GENERIC_UPDATE_COMPLETE,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: { key: "modules.base.barcodes", body: preferences },
                                type: BRAND_GENERIC_UPDATE_COMPLETE,
                            },
                            snackbarAdd({ message: formatMessage("Barcode fields updated") }),
                        ];
                    }
                })
                .catch((error) => {
                    let errorMessage = formatMessage("Error saving barcode fields");
                    if (error.status === 401) {
                        errorMessage = formatMessage("You do not have permission to edit barcode fields");
                    }
                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: new Error(errorMessage),
                            type: BRAND_GENERIC_UPDATE_COMPLETE,
                        }),
                        Observable.of(snackbarAdd({ message: errorMessage }))
                    );
                });
        });
};
